import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import './ForgotPassword.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // 'idle' | 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setStatus('error');
      setMessage('Please enter your email address.');
      return;
    }

    setStatus('loading');
    setMessage('');

    try {
      const response = await api.post('/api/auth/forgot-password', { email });
      setStatus('success');
      setMessage(
        response.data.message ||
        'If an account exists with this email, a password reset link has been sent.'
      );
      setEmail(''); // Clear the form
    } catch (error) {
      setStatus('error');
      setMessage(
        error.response?.data?.detail ||
        'Failed to send reset email. Please try again.'
      );
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <h2>Reset Password</h2>
        <p className="subtitle">
          Enter your email address and we'll send you a link to reset your password.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              disabled={status === 'loading'}
              required
            />
          </div>

          {message && (
            <div className={`message ${status === 'error' ? 'error' : 'success'}`}>
              {message}
            </div>
          )}

          <button
            type="submit"
            className="btn-primary"
            disabled={status === 'loading'}
          >
            {status === 'loading' ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="links">
          <Link to="/login">Back to Login</Link>
          <Link to="/signup">Create Account</Link>
        </div>
      </div>
    </div>
  );
}
